export const openingHours = "Mo. - Do. | 09:00 - 16:00 | Fr. 09:00 - 12:00"
export const openingHoursPL = "Poniedzialek - czwartek | 09:00 - 16:00 | Piątek 09:00 - 12:00"

// Phone
export const phoneNumbers = {
	DE: "+49 800 5895548",
	AT: "+43 800 640357",
}
export const fallBackPhoneNumber = "+43 512 932791"
